<template>
  <b-sidebar
    no-header
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    id="sidebar"
    class="mc-sidebar-liveview mc-sidebar-route"
  >
    <div class="mc-sidebar-liveview__wrapper">
      <div class="mc-sidebar-route__wrapper">
        <FormulateForm
          v-model="formValues"
          name="route-monitoring"
          ref="formRef"
          @submit="handleSubmit"
        >
          <FormulateInput
            type="select-resourceful"
            name="licensePlate"
            :label="$t('global.object.licensePlate')"
            :placeholder="`${$t('global.form.select')} ${$t('global.object.licensePlate')}`"
            :optionsGetter="resourcefulQuery.vehicles"
            :optionLabelFn="
              ({ item }) => {
                return item.licensePlate
              }
            "
            validation="required"
          ></FormulateInput>

          <FormulateInput
            key="expectedDate"
            name="expectedDate"
            class="mt-2"
            :label="$t('global.schedule')"
            :placeholder="$t('global.schedule')"
            type="date-picker"
            validation="required"
            format="DD MMM YYYY"
            valueType="YYYY-MM-DD"
            :showSecond="false"
            :confirm="true"
            :cancel="true"
            :range="true"
            :draft="true"
            :disabled-date="disabledDate"
            :confirmText="$t('global.action.apply')"
          ></FormulateInput>

          <b-button type="submit" variant="primary" size="sm" class="d-block w-100 mt-2"
            ><i class="mc-fa icon-fill_search"></i> {{ $t('global.search') }}</b-button
          >
        </FormulateForm>

        <div class="mc-sidebar-route__monitoring" v-if="listRoute">
          <h4 class="mc-sidebar-route__title">{{ $t('route.routeList') }}</h4>

          <div class="mb-2">
            <div class="mc-sidebar-liveview__filter mc-sidebar-liveview__filter--notif">
              <b-row>
                <b-col md="12">
                  <b-button
                    @click="changeStatus('scheduled')"
                    :variant="`${status === 'scheduled' ? 'secondary' : 'outline-primary'}`"
                    size="sm"
                    >{{ $t('master.status.dijadwalkan') }}</b-button
                  >
                  <b-button
                    @click="changeStatus('progress')"
                    :variant="`${status === 'progress' ? 'info' : 'outline-primary'}`"
                    size="sm"
                    >{{ $t('master.status.dalamPerjalanan') }}</b-button
                  >
                  <b-button
                    @click="changeStatus('done')"
                    :variant="`${status === 'done' ? 'success' : 'outline-primary'}`"
                    size="sm"
                    >{{ $t('master.status.selesai') }}</b-button
                  >
                </b-col>
              </b-row>
            </div>

            <b-row class="mc-sidebar-liveview__search-wrapper">
              <b-col md="8">
                <p class="mc-sidebar-liveview__filter-show mt-2 mb-0">
                  {{ $t('global.show') }} <strong>{{ filteredItems.length }}</strong>
                  {{ $t('master.rute') }}.
                </p>
              </b-col>

              <!-- <b-col md="4" class="text-end">
                <a
                  href="#"
                  class="btn btn-outline-primary"
                  :class="showHideDetail ? 'mc-collapse' : 'mc-expand'"
                  v-on:click="showHideDetail = !showHideDetail"
                >
                  <i class="mc-fa icon-fill_expand"></i>
                  <i class="mc-fa icon-outline_collapse"></i>
                </a>
              </b-col> -->
            </b-row>

            <b-list-group class="mc-sidebar-liveview__list-fleet">
              <b-list-group-item v-for="(row, index) in filteredItems" :key="index">
                <div class="clearfix">
                  <span class="pull-left" @click="showModalRoute(row)">{{ row.route.name }}</span>
                  <b-badge v-if="row.status === 'progress'" class="bg-info">{{
                    $t('master.status.dalamPerjalanan')
                  }}</b-badge>
                  <b-badge v-else-if="row.status === 'done'" class="bg-success">{{
                    $t('master.status.selesai')
                  }}</b-badge>
                  <b-badge v-else-if="row.status === 'scheduled'" class="bg-secondary">{{
                    $t('master.status.dijadwalkan')
                  }}</b-badge>
                  <b-badge v-else-if="row.status === 'cancelled'" class="bg-danger">{{
                    $t('master.status.dibatalkan')
                  }}</b-badge>
                </div>
                <div v-if="showHideDetail" class="mc-sidebar-liveview__list-fleet-showhide">
                  <div class="mc-sidebar-liveview__list-fleet-showhide-wrapper">
                    <div>
                      <span>{{ $t('route.routeMonitoring.actualStartTime') }}</span>
                      <p>{{ row.startOn ? momentDMY_HI(row.startOn) : '-' }}</p>
                    </div>
                    <div>
                      <span>{{ $t('route.routeMonitoring.actualEndTime') }}</span>
                      <p>{{ row.endOn ? momentDMY_HI(row.endOn) : '-' }}</p>
                    </div>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>
            <!-- <b-list-group class="mc-history-fleet__list-total mt-2">
              <b-list-group-item>
                <div>
                  <p>{{ $t('liveView.modal.tripTotal') }}</p>
                  <dl class="clearfix">
                    <dt>
                      {{ $t('liveView.modal.tripDuration') }}
                    </dt>
                    <dd>09:08:21</dd>
                    <dt>
                      {{ $t('liveView.modal.tripDistance') }}
                    </dt>
                    <dd>11.3</dd>
                    <dt>{{ $t('liveView.google.stopDuration') }}</dt>
                    <dd>00:21:32</dd>
                  </dl>
                </div>
              </b-list-group-item>
            </b-list-group> -->
          </div>
        </div>
      </div>
      <ModalRoute :route="route" v-if="!loading" />
    </div>
  </b-sidebar>
</template>

<script>
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import ModalRoute from '../Modal/ModalRoute'
import { GET_VEHICLES_PAGINATED } from '@/services/api/master/fleet'
import { GET_ROUTE_RECORDS } from '@/services/api/route'
import * as routeApi from '@/services/rest-api-vsms/lib/route/route'

export default {
  name: 'SideBarMonitoring',
  components: {
    ModalRoute,
  },
  mixins: [responsive, Helper, MixPanel],

  data() {
    return {
      refetch: true,
      showHideDetail: true,
      listRoute: false,
      formValues: {},
      route: {},

      items: [],
      loading: false,
      status: '',

      routeApi: routeApi,
    }
  },
  computed: {
    resourcefulQuery() {
      return {
        vehicles: this.getVehicles,
      }
    },

    filteredItems() {
      switch (this.status) {
        case 'scheduled':
          return this.items.filter((x) => x.status === 'scheduled')
        case 'progress':
          return this.items.filter((x) => x.status === 'progress')
        case 'done':
          return this.items.filter((x) => x.status === 'done')
        default:
          return this.items
      }
    },
  },

  methods: {
    disabledDate(date) {
      return new Date(date) > new Date()
    },
    async getVehicles(opts) {
      const filter = {
        pagination: {
          page: opts.page,
          show: opts.limit,
        },
        licensePlate: opts.search,
      }

      const res = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_VEHICLES_PAGINATED,
        variables: {
          filter: filter,
        },
      })

      const data = res.data.vehiclesPaginated.vehiclesPaginated
      const result = {
        metadata: {
          total_page: data.pagination.total,
          total_count: data.pagination.total,
          page: data.pagination.page,
        },
        data: {
          paginated_result: data.data,
        },
      }

      return result
    },

    changeStatus(status) {
      if (status == this.status) {
        this.status = ''
        return
      }

      this.status = status
    },

    async showModalRoute(route) {
      this.loading = true
      this.$bvModal.hide('modal-route-monitoring')
      let params = null
      if (
        route.status == 'progress' ||
        route.status == 'done' ||
        (route.status == 'cancelled' && route.startOn != '' && route.startOn != null)
      )
        params = {
          source: 'archived',
          limit: route.startOn,
        }

      const routeData = await routeApi.show(route.route.routeId, params)
      if (routeData.status) {
        this.route = { ...route, ...routeData.data, status: route.status }
        this.$emit('onGetRoute', this.route)
        this.loading = false
        await this.$nextTick()
        this.track
        this.track('View Detail Route Tracking')
        this.$bvModal.show('modal-route-monitoring')
      }
    },

    async handleSubmit() {
      this.listRoute = true

      const res = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_ROUTE_RECORDS,
        variables: {
          filter: {
            pagination: {
              page: 1,
              show: 99999,
            },
            vehicleId: this.formValues.licensePlate,
            dateRange: {
              start: this.momentToISOString(`${this.formValues.expectedDate[0]} 00:00:00`),
              end: this.momentToISOString(`${this.formValues.expectedDate[1]} 23:59:59`),
            },
          },
        },
      })

      this.items = res.data.routeRecords.routeRecords.data
    },
  },
}
</script>
